// Français pour la roadmap — la chronologie, les ateliers, le rail de repli, le chat de l'agent de l'atelier.
// Les statuts, priorités et acteurs (agent/opérateur) viennent du vocabulaire partagé.
import { registerFr } from '../../i18n/index.js';

registerFr({
  // ── l'indice de l'éditeur et les mois ──
  'saves when you leave the field · **fett** · *kursiv* · „- “ für Listen · # inserts a reference':
    'enregistré en quittant le champ · **gras** · *italique* · «- » pour les listes · # insère une référence',
  'Jan': 'Janv.',
  'Feb': 'Févr.',
  'Mar': 'Mars',
  'Apr': 'Avr.',
  'May': 'Mai',
  'Jun': 'Juin',
  'Jul': 'Juil.',
  'Aug': 'Août',
  'Sep': 'Sept.',
  'Oct': 'Oct.',
  'Nov': 'Nov.',
  'Dec': 'Déc.',

  // ── refus et pannes ──
  'The items did not load.': 'Les éléments de contenu n’ont pas été chargés.',
  'The change was refused.': 'La modification a été refusée.',
  'The item was refused.': 'L’élément de contenu a été refusé.',
  'The agent did not answer.': 'L’agent n’a pas répondu.',
  'The hold was refused.': 'La retenue a été refusée.',
  'The transcript did not load.': 'La transcription n’a pas été chargée.',
  '#{id} held — it landed in Contents': '#{id} retenu — il se trouve désormais dans Contenu',

  // ── l'en-tête de l'atelier ──
  'Workbench {ref}': 'Atelier {ref}',
  '{ref} renamed': '{ref} renommé',
  'Edit the name': 'Modifier le nom',
  'due {date}': 'échéance {date}',
  'Previous deliverable in this bench': 'Livrable précédent dans cet atelier',
  'Next deliverable in this bench': 'Livrable suivant dans cet atelier',
  'Close this bench': 'Fermer cet atelier',

  // ── description / definition of done ──
  'Description': 'Description',
  'Edit the description': 'Modifier la description',
  'What this deliverable is.': 'Ce qu’est ce livrable.',
  '{ref} description saved': '{ref} description enregistrée',
  '— no description yet': '— pas encore de description',
  'Definition of done': 'Critères d’acceptation',
  'Edit the definition of done': 'Modifier les critères d’acceptation',
  'The observable condition under which this is finished.': 'La condition observable sous laquelle ceci est terminé.',
  '{ref} definition of done saved': '{ref} critères d’acceptation enregistrés',
  '— not defined yet': '— pas encore définie',

  // ── les éléments de contenu ──
  'Contents': 'Contenu',
  'sorted by date · ◇ drafted · ▪ held': 'triés par date · ◇ brouillon · ▪ retenu',
  'Edit the title': 'Modifier le titre',
  'undated': 'sans date',
  'Move up': 'Monter',
  'Move down': 'Descendre',
  'Specify this piece — what it contains, how it is judged…': 'Spécifier cet élément — ce qu’il contient, comment il est évalué…',
  '— no specification yet': '— pas encore de spécification',
  'Edit the specification': 'Modifier la spécification',
  'Due': 'Échéance',
  'changing the date re-sorts the list': 'un changement de date réorganise la liste',
  'Satisfies': 'Satisfait',
  'which of this deliverable’s requirements the piece serves': 'à quelles exigences de ce livrable cet élément répond',
  'Documents': 'Documents',
  'Detach': 'Détacher',
  '+ Attach…': '+ Joindre…',
  'Provenance': 'Provenance',
  'Hold ▪': 'Retenir ▪',
  'Back to draft ◇': 'Revenir au brouillon ◇',
  'Drop': 'Abandonner',
  'No content items yet — add one below, or ask the agent.': 'Pas encore d’élément de contenu — en ajouter un ci-dessous, ou demander à l’agent.',
  'Add a content item by hand…': 'Ajouter un élément de contenu à la main…',
  'Add': 'Ajouter',

  // ── affiner avec l'agent ──
  'Refine with the agent': 'Affiner avec l’agent',
  // le panneau de chat : le repli, le sélecteur, la zone de saisie
  'Fold the chat in': 'Replier le chat',
  'Fold the chat out': 'Déplier le chat',
  'Conversations': 'Conversations',
  'New conversation': 'Nouvelle conversation',
  'Close the conversation list': 'Fermer la liste des conversations',
  'Jump to the latest': 'Aller au plus récent',
  'Enter sends · Shift+Enter starts a new line': 'Entrée envoie · Maj+Entrée insère une nouvelle ligne',
  'this deliverable': 'ce livrable',
  'all conversations': 'toutes les conversations',
  'run #{id}': 'exécution #{id}',
  'A conversation scoped to {ref} — it stays here when you close the bench, and lands in “all conversations” for good.': 'Une conversation liée à {ref} — elle reste ici lorsque vous fermez l’atelier, et atterrit définitivement dans «toutes les conversations».',
  'agent · proposes into the queue, writes nothing': 'agent · propose dans la file d’attente, n’écrit rien',
  'Hold': 'Retenir',
  '{status} · in the queue': '{status} · dans la file d’attente',
  'agent': 'agent',
  'thinking…': 'réfléchit…',
  'Ask — e.g. "Break {name} down further"': 'Demander — p. ex. «Décomposez {name} davantage»',
  'Ask →': 'Demander →',
  '← all conversations': '← toutes les conversations',
  'run #{id} · {date} · {status}': 'exécution #{id} · {date} · {status}',
  'No transcript on record — a live run writes it when it ends.': 'Aucune transcription enregistrée — une exécution en cours l’écrit lorsqu’elle se termine.',
  'reading the conversations…': 'chargement des conversations…',
  'conversation': 'conversation',
  'No conversations in this engagement yet.': 'Pas encore de conversations dans ce mandat.',
  'The agent proposes, you hold — held items land in Contents with their provenance; refusals keep their reason and teach the next run.': 'L’agent propose, vous retenez — les éléments retenus atterrissent dans Contenu avec leur provenance ; les refus conservent leur justification et instruisent l’exécution suivante.',

  // ── l'aparté des exigences ──
  '{n} requirement · a source ref opens the span': '{n} exigence · une référence source ouvre l’extrait',
  '{n} requirements · a source ref opens the span': '{n} exigences · une référence source ouvre l’extrait',
  'Show the span {ref} cites in {doc}': 'Afficher l’extrait que {ref} cite dans {doc}',

  // ── le plateau ──
  '{refs} folded to the right — the dock shows {n} at this width': '{refs} replié(s) à droite — le Dock affiche {n} à cette largeur',
  '{ref} → due {date}': '{ref} → échéance {date}',
  'The roadmap': 'La Roadmap',
  'drag a card = re-date · pull an edge = stretch · grab the grid = pan · click = work out (click another = beside it)': 'glisser une carte = redater · tirer un bord = étirer · saisir la grille = déplacer · cliquer = développer (cliquer un autre = à côté)',
  'Faint lines are weeks, stronger lines are months.': 'Les lignes fines représentent les semaines, les lignes marquées les mois.',
  'A drag writes {start} / {due} and an audit row.': 'Un glissement écrit {start} / {due} et une ligne de piste d’audit.',
  'Undated deliverables wait in the tray until you date them — drag one onto the grid.': 'Les livrables sans date patientent dans le bac jusqu’à ce que vous leur donniez une date — glissez-en un sur la grille.',
  'Drag onto the roadmap to date it · click to work it out': 'Glisser sur la roadmap pour dater · cliquer pour élaborer',
  '{ref} → undated — back in the tray': '{ref} → sans date — de retour dans le bac',
  '{ref} is dated on the record — switch to “As recorded” to pull it back.': '{ref} est daté au dossier — passez à « Au dossier » pour le retirer.',
  'drop a card here to undate it': 'déposez une carte ici pour retirer sa date',
  '{ref} pinned to its lane': '{ref} épinglé à sa voie',
  '{ref} unmapped — the requirement itself stays': '{ref} dissocié — l’exigence elle-même demeure',
  'Referenced in': 'Référencé dans',
  'texts that name {ref} — change it and they may need to move along': 'textes qui nomment {ref} — si vous le changez, ils devront peut-être suivre',
  'Unmap {ref} from this deliverable — the requirement itself stays': 'Dissocier {ref} de ce livrable — l’exigence elle-même demeure',
  'Workbenches': 'Ateliers',
  'Folded benches': 'Ateliers repliés',
  'Close {ref}': 'Fermer {ref}',
  '{ref} · {name} — unfold': '{ref} · {name} — déplier',
  'Expand the roadmap to the full screen': 'Étendre la Roadmap à l’écran complet',
  'Back to the page width': 'Revenir à la largeur de la page',
  'all': 'toutes',
  '+ New conversation': '+ Nouvelle conversation',
  'No conversations here yet.': 'Pas encore de conversations ici.',
  'A conversation scoped to {ref} — it is kept for good and comes back whenever you reopen the bench.': 'Une conversation liée à {ref} — elle est conservée définitivement et revient chaque fois que vous rouvrez l’atelier.',
  'in the queue': 'dans la file d’attente',

  // — merged in from the pencil-layer branch —
  'As recorded': 'Au dossier',
  'With assumptions': 'Avec hypothèses',
  'Which roadmap you are looking at': 'Quelle Roadmap vous regardez',
  'The dates the engagement is held to — a drag writes them': 'Les dates qui engagent le mandat — un glissement les écrit',
  'The plan: assumptions drawn where they are pencilled, the record left as a faint slot — a drag writes the assumption': 'La planification : les hypothèses dessinées là où elles sont esquissées, la date au dossier laissée en creux — un glissement écrit l’hypothèse',
  'drag a card = re-plan the assumption · the record does not move · click = work out': 'glisser une carte = replanifier l’hypothèse · la date au dossier ne bouge pas · clic = travailler',
  'Assumption': 'Hypothèse',
  'Assumption — waiting on {ref}: {question}': 'Hypothèse — en attente de {ref} : {question}',
  '{ref} on the record: {date}': '{ref} au dossier : {date}',
  '{ref} planned for {date} — assumption, waiting on {q}': '{ref} planifié au {date} — hypothèse, en attente de {q}',
  '{ref} has no open question to hang an assumption on — tether one in the workbench first.': '{ref} n’a aucune question ouverte à laquelle rattacher une hypothèse — rattachez-la d’abord dans l’atelier.',
  'You are looking at the plan: a dashed card is an assumption, the faint slot behind it is what the engagement is held to. Settling its question on the client call reverts it or adopts it.': 'Vous regardez la planification : une carte en pointillé est une hypothèse, le creux derrière elle est ce qui engage le mandat. Trancher sa question lors de l’entretien client l’abandonne ou l’adopte.',
  'Assumptions are pencilled on this roadmap — switch to “With assumptions” to see them.': 'Des hypothèses sont esquissées sur cette Roadmap — passez à «Avec hypothèses» pour les voir.',
  'An assumption is planned in a workbench: pick a date, hang it on the open question that has to settle first.': 'Une hypothèse se planifie dans un atelier : choisissez une date, puis rattachez-la à la question ouverte qui doit d’abord être tranchée.',
  'Dates': 'Dates',
  'Start': 'Début',
  'the record · an assumption is planned beside it, never over it': 'au dossier · une hypothèse se planifie à côté, jamais par-dessus',
  'as an assumption': 'comme hypothèse',
  'plan as an assumption': 'planifier comme hypothèse',
  'Plan this date as an assumption, tethered to an open question — the record does not move': 'Planifier cette date comme hypothèse, rattachée à une question ouverte — la date au dossier ne bouge pas',
  'The open question this assumption waits on': 'La question ouverte que cette hypothèse attend',
  'The date you are assuming': 'La date que vous supposez',
  'every other open question': 'toutes les autres questions ouvertes',
  'why, in one line — optional': 'pourquoi, en une ligne — facultatif',
  'Pencil it in': 'Esquisser la date',
  'Cancel': 'Annuler',
  'Rub this assumption out — the record never moved': 'Effacer cette hypothèse — la date au dossier n’a jamais bougé',
  'Nothing open to hang an assumption on — a pencilled date has to say what it waits on.': 'Aucune question ouverte à laquelle rattacher une hypothèse — une date esquissée doit dire ce qu’elle attend.',
  'The assumption was refused.': 'L’hypothèse a été refusée.',
  'under clarification': 'en clarification',
  'An open question names {ref} — this ground is not settled yet': 'Une question ouverte nomme {ref} — ce terrain n’est pas encore tranché',
  'A drag writes an assumption over {start} / {due} — never the row itself.': 'Un glissement écrit une hypothèse sur {start} / {due} — jamais la ligne elle-même.',

  // ── la moitié « statut » de la couche crayon : PROVISOIRE (◈), et la file en attente (◇)
  // qui atteint l’atelier ──
  'Provisional': 'Provisoire',
  'Provisional — waiting on {ref}: {question}': 'Provisoire — en attente de {ref} : {question}',
  'Clear this mark — the record never moved': 'Effacer cette marque — le dossier n’a jamais bougé',
  'mark provisional': 'marquer comme provisoire',
  'Mark provisional ◈': 'Marquer comme provisoire ◈',
  'The open question this mark waits on': 'La question ouverte que cette marque attend',
  'The mark was refused.': 'La marque a été refusée.',
  'Nothing open to tether a provisional mark to — mark one only once a question is open to settle it.':
    'Aucune question ouverte à laquelle rattacher une marque provisoire — n’en posez une que lorsqu’une question est ouverte pour la trancher.',
  'Mark this deliverable provisional, tethered to an open question — a standing override, not the record itself':
    'Marquer ce livrable comme provisoire, rattaché à une question ouverte — une réserve de statut, pas le dossier lui-même',
  'Mark {ref} provisional, tethered to an open question — a standing override, not the record itself':
    'Marquer {ref} comme provisoire, rattaché à une question ouverte — une réserve de statut, pas le dossier lui-même',
  'Untreated': 'Non traité',
  '◇ said by the agent, not yet judged': '◇ dit par l’agent, pas encore jugé',
  '{n} untreated': '{n} non traité',
  '{n} proposal from the agent is still waiting on a Hold or a decision': '{n} proposition de l’agent attend encore d’être retenue ou tranchée',
  '{n} proposals from the agent are still waiting on a Hold or a decision': '{n} propositions de l’agent attendent encore d’être retenues ou tranchées',
  'untreated': 'non traité',
  '#{id} held — the mark is set': '#{id} retenue — la marque est posée',
  'a provisional mark': 'une marque provisoire',
  'The agent has proposed a provisional mark here — not yet judged': 'L’agent a proposé ici une marque provisoire — pas encore jugée',
  'The agent has proposed provisional marks here — not yet judged': 'L’agent a proposé ici des marques provisoires — pas encore jugées',

  // ── the dependency linker ──
  'Linked': 'Lié',
  'builds on · when the linked content changes, this side is flagged': 's’appuie sur · si le contenu lié change, ce côté est signalé',
  '+ Link…': '+ Lier…',
  'builds on': 's’appuie sur',
  'builds on this': 's’appuie sur ceci',
  'builds on {ref}': 's’appuie sur {ref}',
  'The deliverable this one builds on': 'Le livrable sur lequel celui-ci s’appuie',
  'pick a deliverable…': 'choisir un livrable…',
  'Pin this side to one of its content items — optional': 'Épingler ce côté à l’un de ses éléments de contenu — optionnel',
  'this whole deliverable': 'ce livrable entier',
  'Pin the other side to one of its content items — optional': 'Épingler l’autre côté à l’un de ses éléments de contenu — optionnel',
  'their whole deliverable': 'leur livrable entier',
  'Link': 'Lier',
  'The link was refused.': 'Le lien a été refusé.',
  'Open the {ref} bench beside this one': 'Ouvrir l’établi {ref} à côté de celui-ci',
  'via {ref}': 'via {ref}',
  'Recorded when a cross-deliverable proposal was held': 'Enregistré lorsqu’une proposition inter-livrables a été retenue',
  'The linked content changed after this deliverable last reconciled with it': 'Le contenu lié a changé depuis le dernier rapprochement de ce livrable',
  'linked content changed': 'contenu lié modifié',
  'Adapt with the agent': 'Adapter avec l’agent',
  'Mark it reconciled — nothing needed adapting': 'Marquer comme rapproché — rien n’a dû être adapté',
  'Reconciled ✓': 'Rapproché ✓',
  'Remove this link': 'Supprimer ce lien',
  '— nothing linked yet · a link says whose content this deliverable builds on': '— rien de lié encore · un lien dit sur quel contenu ce livrable s’appuie',
  'Content this deliverable builds on has changed — open the bench to reconcile': 'Le contenu sur lequel ce livrable s’appuie a changé — ouvrir l’établi pour rapprocher',
  'This proposal lands in {ref} — it appears in that bench and in the review queue': 'Cette proposition atterrit dans {ref} — elle apparaît dans cet établi et dans la file de revue',
  'Proposed from the {ref} workbench — its refinement needs something here': 'Proposé depuis l’établi {ref} — son élaboration a besoin de quelque chose ici',
  'Proposed by the roadmap planner — it judged the plan as a whole': 'Proposé par le planificateur de la Roadmap — il a jugé le plan dans son ensemble',
  'from the planner': 'du planificateur',
  'from {ref}': 'depuis {ref}',
  '#{id} held — the amendment is applied': '#{id} retenue — l’amendement est appliqué',
  '#{id} held': '#{id} retenue',
  '{ref} — the content this deliverable builds on in {other} has changed. Compare against {other} and propose adaptations to my content items here.':
    '{ref} — le contenu sur lequel ce livrable s’appuie dans {other} a changé. Compare avec {other} et propose ici des adaptations à mes éléments de contenu.',
}, 'RoadmapView');
